import { render, staticRenderFns } from "./ProjektAnsprechpartner.vue?vue&type=template&id=2b5a6b20&"
import script from "./ProjektAnsprechpartner.vue?vue&type=script&lang=js&"
export * from "./ProjektAnsprechpartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports